<template>
    <div>
      <div class="mb-3">
        <div class="row">
          <div class="col-auto d-flex justify-content-center align-items-center">
            <button type="button" @click="$emit('close')" class="btn btn-light mb-2 rounded-circle" style="width: 50px !important; height: 50px !important; display: flex !important; justify-content: center !important; align-items: center !important;"><i class="bi bi-x"></i></button>
          </div>
          <div class="col-lg-11">
            <a class="text-decoration-none text-primary"><b>{{ data.Nombre }}</b></a>
            <p class="mb-0">País: <b>{{ data.Pais }}</b></p>
            <p class="mb-0">Dirección: <b>{{ data.Direccion }}</b></p>
            <p class="mb-0">Resultados: <b>{{ onGroup(data.InfoTrackingPaquete, function (x) { return x.Guia }).length }}</b></p>
          </div>
        </div>
      </div>
      <v-app v-if="result == 1">
          <div class="text-center mt-2">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
      </v-app>
      <div v-if="data && result == 0">
          <v-app>
              <div class="table-responsive">
                  <v-data-table class="elevation-0"
                      :headers="headers"
                      :items="onGroup(this.data.InfoTrackingPaquete, function (x) { return x.Guia })"
                      dense
                      :items-per-page="10">
                      <template v-slot:[`item.action`]="{ item }">
                        <router-link :to="{ name: 'CompanyTracking', query: { guia: item.key } }" class="btn btn-dark text-white my-2 rounded-circle text-decoration-none" style="width: 30px !important; height: 30px !important; display: flex !important; justify-content: center !important; align-items: center !important;"><i class="bi bi-arrow-right-short"></i></router-link>
                      </template>
                  </v-data-table>
              </div>
          </v-app>
      </div>
    </div>
</template>
<script>
import moment from 'moment-timezone'
import timezones from '@/assets/json/timezones.json'
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    result: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    headers: [
      { text: 'Guia', value: 'key' },
      { text: 'Evento', value: 'Evento' },
      { text: 'Fecha Captura', value: 'FechaCaptura' },
      { text: 'Ubicacion', value: 'Ubicacion' },
      { text: 'Acción', value: 'action' }
    ]
  }),
  methods: {
    onGroup: function (data, lambda) {
      data = data.map(e => {
        return {
          Evento: e.Evento,
          FechaCaptura: this.onFormat(e.FechaCaptura, this.data.Pais),
          FechaEvento: e.FechaEvento,
          Guia: e.Guia,
          SiguienteUbicacion: e.SiguienteUbicacion,
          Ubicacion: e.Ubicacion
        }
      })
      console.log(data)

      return data.sort((a, b) => { return new Date(b.FechaCaptura) - new Date(a.FechaCaptura) }).reduce(function (groups, current) {
        var val = lambda(current)
        var index = groups.findIndex(function (x) {
          return x.key === val
        })
        if (index < 0) {
          index = groups.push({
            key: val,
            items: []
          }) - 1
        }

        groups[index].items.push(current)

        groups[index].Evento = data[index].Evento
        groups[index].FechaCaptura = data[index].FechaCaptura
        groups[index].Ubicacion = data[index].Ubicacion

        return groups
      }, [])
    },
    onFormat: function (date, country) {
      let c = timezones.find((e) => e.name === country.replace(' (the)', ''))
      if (c.name === 'United States of America') {
        c.name = 'New York'
      }
      var gt = moment.tz(String(date), 'DD/MM/YYYY hh:mm:ss', c.region + '/' + c.name.replace(/\s/g, '_'))
      var guatemala = gt.clone().tz('America/Guatemala')
      return guatemala.format('YYYY/MM/DD hh:mm A')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company/components/tables/Screen3.vue